export const castPath = (path: string, exact?: boolean) => {
  return exact ? path : `${path}${path.endsWith('/') ? '' : '/'}*`;
};
